import { render } from "./card-icon.vue.js?vue&type=template&id=653c961a!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./card-icon.vue?vue&type=template&id=653c961a"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__